import { render, staticRenderFns } from "./SortSelector.vue?vue&type=template&id=73a0981d&scoped=true&"
import script from "./SortSelector.vue?vue&type=script&lang=ts&"
export * from "./SortSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SortSelector.vue?vue&type=style&index=0&id=73a0981d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a0981d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
